import { Component, ViewChild } from '@angular/core';
import { LegacyPageEvent as PageEvent, MatLegacyPaginator as MatPaginator, } from '@angular/material/legacy-paginator';
import { Subscription } from 'rxjs';
import { Project } from 'src/app/models/project.model';
import { ProjectService } from 'src/app/services/project.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css'],
})
export class ProjectsComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  apiUrl = environment.apiUrl;
  listOfProjects = this.projectService.projects;

  breakpoint: number;
  gutter: string;
  longText = `The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog
  from Japan. A small, agile dog that copes very well with mountainous terrain, the Shiba Inu was
  originally bred for hunting.`;

  image =
    'https://res.cloudinary.com/dyekwrvwe/image/upload/v1709258959/placeholder_b3miif.jpg';

  showSpinner: boolean = true;

  projects: Project[] = [];
  projectSubscription$: Subscription;
  isIconEmpty: boolean = true;
  isImgEmpty: boolean = false;

  showLogo: boolean = false;
  showProjectImage: boolean = false;

  pagedList: Project[] = [];
  length: number = 0;
  pageSize: number = 6;
  pageSizeOptions: number[] = [3, 6, 9, 12];
  fullTitle: string = '';

  constructor(private readonly projectService: ProjectService) {
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    if (window.innerWidth <= 576) {
      this.breakpoint = 1;
    } else if (window.innerWidth <= 992) {
      this.breakpoint = 1;
    } else if (window.innerWidth <= 1200) {
      this.breakpoint = 2;
    } else if (window.innerWidth <= 1400) {
      this.breakpoint = 2;
    } else {
      this.breakpoint = 3;
    }

    this.projectService.getAllProjects();

    this.projectSubscription$ = this.projectService.projectSubject$
      .subscribe(
        (response: Project[]) => {
          this.projects = response.map((project) => {
            let subDes = project.content.replace(/<(.+?)>/g, '');
            if (subDes.length > 140) {
              subDes = subDes.substring(0, 140);
              subDes = subDes.substring(0, subDes.lastIndexOf(' '));
              subDes += ' ...';
            }
            project.content = subDes;
            project.content = project.content.substring(0, 250);
            if (typeof project.sponsor_images_url === 'string') {
              try {
                project.sponsor_images_url = this.convertStringToArray(
                  project.sponsor_images_url
                );
              } catch (error) {
                console.error('Error parsing sponsor_images_urls:', error);
                project.sponsor_images_url = [];
              }
            }


            if (
              project.project_icon_url == ' ' ||
              project.project_icon_url == null
            ) {
              this.isIconEmpty = false;
            }

            if (
              project.project_image_url == ' ' ||
              project.project_image_url == null
            ) {
              this.isImgEmpty = true;
            } else {
              this.isImgEmpty = false;
            }

            if (project?.project_icon_url?.startsWith("https")) {
              this.showLogo = false;
              project.showLogo = true
            } else {
              this.showLogo = true;
              project.showLogo = false
            }

            if (project?.project_image_url?.startsWith("https")) {
              this.showLogo = false;
              project.showProjectImage = true
            } else {
              this.showLogo = true;
              project.showProjectImage = false
            }
            this.fullTitle = project.title;
            project.fullTitle = this.fullTitle;
            project.title =
              project.title.length > 28
                ? project.title.substring(0, 28) + ' ...'
                : project.title;
            return project;
          });

          this.projects = this.projects.sort((a, b) => {
            const dateA = a.start_date ? new Date(a.start_date).getTime() : 0;
            const dateB = b.start_date ? new Date(b.start_date).getTime() : 0;
            return dateB - dateA; // Descending order (most recent start date first)
          })
          this.pagedList = this.projects.slice(0, 6);
          this.length = this.projects.length;
          this.showSpinner = false;
        }
      );
  }

  OnPageChange(event: PageEvent) {
    let startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;
    if (endIndex > this.length) {
      endIndex = this.length;
    }
    this.pagedList = this.projects.slice(startIndex, endIndex);
  }

  onResize(event: any) {
    if (event.target.innerWidth <= 576) {
      this.breakpoint = 1;
    } else if (event.target.innerWidth <= 992) {
      this.breakpoint = 1;
    } else if (event.target.innerWidth <= 1200) {
      this.breakpoint = 2;
    } else if (event.target.innerWidth <= 1400) {
      this.breakpoint = 2;
    } else {
      this.breakpoint = 3;
    }
  }

  learnMore(project: Project) {
    //window.location.href = project. ?? '';
  }

  // carry this code into a helper service later
  convertStringToArray(inputString: any) {
    const trimmedString = inputString.trim();

    // Check if the string starts and ends with square brackets
    if (trimmedString.startsWith('[') && trimmedString.endsWith(']')) {
      // Remove the square brackets
      const stringWithoutBrackets = trimmedString.slice(1, -1);

      // Split the remaining string by commas
      const stringArray = stringWithoutBrackets.split(',');

      // Trim and wrap each element in single quotes
      const resultArray = stringArray.map(
        (element: any) => `${element.trim().slice(1, -1)}`
      );

      return resultArray;
    } else {
      console.error('Input is not in the expected format.');
      return [];
    }
  }

  ngOnDestroy(): void {
    this.projectSubscription$.unsubscribe();
  }
}
